import { render, staticRenderFns } from "./AppTabConfigForm.vue?vue&type=template&id=faf7c438&"
import script from "./AppTabConfigForm.vue?vue&type=script&lang=js&"
export * from "./AppTabConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./AppTabConfigForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports